<template>
  <div id="calendar" class="">
    <v-toolbar flat class="toolbar cont text-xs-center">
      <v-toolbar-title>
        <h2
          class="textColor text-xs-center font-weight-bold text-capitalize f-20"
        >
          Select Your Date & Time
        </h2>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <div class="btn-tool text-xs-right">
        <v-btn icon small class="ma-0">
          <v-icon class="f-25 text-primary">close</v-icon>
        </v-btn>
      </div> -->
    </v-toolbar>

    <v-container fluid grid-list-md class="pa-0">
      <template class="text-xs-center">
        <v-date-picker
          :events="arrayEvents"
          event-color="green"
          @input="getTimeForBooking(selectedDate)"
          v-model="selectedDate"
          color="transprant"
          class="pa-0 ma-0 text-primary no-shadow"
          max-width="640"
        ></v-date-picker>
      </template>
      <v-layout row wrap class="px-3">
        <v-flex xs4 v-for="i in availableTime" class="pa-1">
          <v-btn
            @click="confirmClass(i)"
            small
            class="green w-100 ma-0 text-white"
            >{{ i.time_from }}</v-btn
          >
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog class="pa-0 display-unset" v-model="complete" width="400">
      <v-card class="pa-2 card-r grey lighten-4">
        <v-container fluid grid-list-md class="text-xs-center pa-0">
          <v-layout row wrap class="">
            <v-flex xs12 class="pb-0 pl-0">
              <div class="f-20 t-color-grey-d font-weight-bold">
                {{ cls_detail.name }}
                <span class="f-14"></span>
              </div>
              <div class="f-25 text-primary font-weight-bold">
                {{ completeClassData.date }}, {{ completeClassData.time_from }}
              </div>
              <div class="f-16 text-primary font-weight-bold">
                {{ completeClassData.teacher_name }}
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-btn
                @click="bookClass(completeClassData)"
                class="w-100 ma-0 primary text-white text-capitalize"
                round
                :loading="loading"
                v-if="AlertMsg == ''"
                >Confirm</v-btn
              >
              <v-alert :value="true" :type="alertType" v-if="AlertMsg != ''">
                {{ AlertMsg }}
              </v-alert>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */

import api from "@/utils/backend-api";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    PulseLoader
  },
  props: [
    "cls_detail",
    "cls_times",
    "moduleId",
    "teacherId",
    "packageId",
    "CalendarBookingType",
    "selectedBookTime"
  ],
  data() {
    return {
      sheet: false,
      booked: false,
      complete: false,
      dialog: false,
      viewModulePopup: false,
      viewModulePopupData: [],
      cards: [
        {
          title: "Urban Drive",
          date: "19.03.2019",
          time: "   02.00PM",
          src:
            "https://irp-cdn.multiscreensite.com/f6d3566d/dms3rep/multi/mobile/iStock-540862480-2121x1414.jpg",
          flex: 12
        }
        // { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
        // { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }
      ],
      ChangeTime: false,
      seen: true,
      // selectedBookTime: "",
      birthday: false,
      dob: "",
      menu1: "",
      timeslot: [
        { times: "10.00am" },
        { times: "11.00am" },
        { times: "12.00pm" },
        { times: "01.00pm" },
        { times: "02.00pm" }
      ],
      whats_app: ["vacation ", "sick"],
      selectedDate: "",
      selectedDate1: "",
      student_bookings: [],
      teacher_bookings: [],
      teacher_events: "",
      noValues: "",
      loading: false,
      arrayEvents: [],
      loading1: false,
      alertType: "",
      msg: "",
      eventAlert: "",
      eventMsg: "",
      // arrayEvents:[],
      selectedClassId: "",
      selectedClassPackageId: "",
      selectedClass: "",
      teacherTime: "",
      tempItems: [],
      items: [],
      AlertMsg: "",
      pendingClassAlert: false,
      pendingClassAlertMsg: "",

      availableTime: [],
      selectedTimeForBook: "",
      completeClassData: []
    };
  },
  created: function() {
    let moduleId = this.moduleId;
    let packageId = this.packageId;
    let teacherId = this.teacherId;
    let studentId = Store.state.user.id;

    // this.setClassDetails(moduleId,packageId,'',studentId)
    // this.getCalendarEvents();
    this.setCalendarDates();
    if(this.selectedBookTime!=null){
      this.selectedDate=this.selectedBookTime.date
      this.getTimeForBooking(this.selectedBookTime.date)
    }
  },
  methods: {
    bookClass(payload) {
      let self = this;
      let formData = {
        student_id: this.$route.params.id,
        package_id: this.cls_detail.package_id,
        module_id: this.cls_detail.id,
        teacher_bookings_id: payload.id,
        payment_type: "manual"
      };
      self.loading = true;
      api
        .postData("booking_2/admin/bookClass", formData)
        .then(res => {
          self.loading = false;
          if (res.status == 200) {
            self.alertType = "info";
            self.AlertMsg = res.data.error.message;
            setTimeout(() => {
              self.AlertMsg = "";
              self.complete = false;
            }, 2000);
          } else if (res.status == 201) {
            self.alertType = "success";
            self.AlertMsg = "Successfully booked";
            self.complete = false;
          }
        })
        .catch(err => {
          // if (err.response.status == 422) {
          self.alertType = "error";
          self.AlertMsg = "Booking failed";
          setTimeout(() => {
            self.complete = false;
            self.AlertMsg = "";
          }, 2000);
          // }
          self.loading = false;
        });
      // this.complete=false
    },
    confirmClass(classData) {
      this.completeClassData = classData;
      this.complete = true;
    },
    setCalendarDates() {
      let arrayEvents = [];
      for (var x = 0; x < this.cls_times.length; x++) {
        var date = this.cls_times[x].date;
        arrayEvents.push(date);
      }
      this.arrayEvents = arrayEvents;
      this.selectedDate = arrayEvents[0];
    },
    // getCalendarEvents() {
    // let self = this;
    // api.postData('booking_2/admin/getTime',{student_id:this.$route.params.id,module_id:this.moduleId,package_id:this.cls_detail.packageId,class_location:cls_detail})
    // .then(res=>{
    //   const response=res.data
    //   let arrayEvents=[]
    //     for(var x=0;x<response.times.length;x++){
    //       for(var y=0;y<response.times[x].length;y++){
    //         var date=response.times[x][y].date
    //           arrayEvents.push(date)
    //       }
    //     }
    //     self.arrayEvents = arrayEvents
    //     self.selectedDate=arrayEvents[0]
    // })
    // },
    SetSelectedTimeForBook(selectedTime) {
      this.selectedTimeForBook = selectedTime;
      this.booked = true;
    },
    getTimeForBooking(selectedData) {
      let times = [];
      for (let x = 0; x < this.cls_times.length; x++) {
        if (this.cls_times[x].date == selectedData) {
          times.push(this.cls_times[x]);
        }
      }
      console.log(times);
      this.availableTime = times;
    },
    getTimeForBooking_temp() {
      let self = this;
      api
        .postData("booking_2/admin/getTimeByDate", {
          module_id: this.cls_detail.id,
          package_id: this.cls_detail.package_id,
          teacher_id: this.cls_detail.teacherId,
          student_id: this.$router.history.current.params.id,
          date: this.selectedDate
        })
        .then(res => {
          if (res.status == 200) {
            self.availableTime = res.data.times;
          } else {
            self.availableTime = [];
          }
        })
        .catch(err => {
          self.availableTime = [];
        });
    },
    CheckPendingClass(moduleId, packageId, className = "", studentId, date) {
      let data = {
        student_id: studentId,
        module_id: moduleId,
        package_id: packageId,
        date: date
      };
      let self = this;
      api
        .postData("student/student_class/studentCheckBookClass", data)
        .then(res => {
          if (res.data.booking_error_message != null) {
            self.pendingClassAlert = true;
            self.pendingClassAlertMsg =
              res.data.booking_error_message.errorMessage;
          } else {
            self.pendingClassAlert = false;
          }
          // self.availableTime=res.data
        })
        .catch(err => {});
    },
    setClassDetails(moduleId, packageId, className = "", studentId) {
      this.dob = "";
      this.selectedTime = "";

      this.selectedClassId = moduleId;
      this.selectedClassPackageId = packageId;
      this.selectedClass = className;
      // console.log(classId,packageId,className)

      this.msg = false;
      this.msgText = "";
      this.alertType = "";
      this.arrayEvents = [];
      // let student_id=user.user.id
      // let module_id=moduleId
      // let package_id=packageId

      this.timeslot = [];
      let data = {
        student_id: studentId,
        module_id: moduleId,
        package_id: packageId
      };

      let self = this;
      // Store.dispatch("student/student_class/get_time",data)
      api
        .postData("student/student_class/get_time", data)
        .then(res => {
          if (res.status == 204) {
            self.loading = false;
            self.msgText = "No time for booking this module";
            self.alertType = "warning";
            self.AlertMsg = true;
          } else if (res.status == 203) {
            self.loading = false;
            self.msgText = "Not buy this package.";
            self.alertType = "warning";
            self.AlertMsg = true;
          } else if (res.status == 200) {
            self.teacherTime = res.data;

            self.alertType = "";
            self.msgText = "";
            self.AlertMsg = false;
            self.arrayEvents = [];

            const response = res.data;
            for (var x = 0; x < response.times.length; x++) {
              for (var y = 0; y < response.times[x].length; y++) {
                var date = response.times[x][y].date;
                self.arrayEvents.push(date);
              }
            }

            let arrayEvents = self.arrayEvents;
            arrayEvents.sort(function compare(a, b) {
              var dateA = new Date(a);
              var dateB = new Date(b);
              return dateA - dateB;
            });

            self.selectedDate = arrayEvents[0];
            self.loading = false;
            // }, 500);
          } else {
            self.loading = false;
            self.alertType = "warning";
            self.AlertMsg = "No time to book self module";
          }
        })
        .catch(err => {
          if (err.response.status == 203) {
            self.AlertMsg = err.response.error.message;
          }
          self.loading = false;
          self.alertType = "warning";
          self.AlertMsg = "No time to book this module";
        });
      this.ChangeTime = true;
    },
    GetTime(selectedDate) {
      let moduleId = this.moduleId;
      let packageId = this.packageId;
      let className = this.className;
      let studentId = Store.state.user.id;
      this.CheckPendingClass(
        moduleId,
        packageId,
        className,
        studentId,
        selectedDate
      );
      let self = this;
      this.timeslot = [];
      this.items = [];
      var time = [];
      this.eventAlert = "";
      this.eventMsg = "";

      for (var x = 0; x < this.teacherTime.times.length; x++) {
        for (var y = 0; y < this.teacherTime.times[x].length; y++) {
          if (this.teacherTime.times[x][y].date == selectedDate) {
            var Data = {
              id: this.teacherTime.times[x][y].id,
              time_from: this.teacherTime.times[x][y].time_from,
              time_to: this.teacherTime.times[x][y].time_to,
              minutes: this.teacherTime.times[x][y].minutes
            };
            time.push(Data);
          }
        }
      }
      this.timeslot = time;
      self.items = time;
      this.sheet = true;
    },
    BookClass(classId, packageId, selectedTimeId) {
      // console.log("BookClass")
      let self = this;
      this.loading = true;
      let Data = {
        module_id: this.selectedClassId,
        package_id: this.selectedClassPackageId,
        teacher_bookings_id: selectedTimeId
      };
      // console.log(Data)
      api
        .postData("student/student_class/book", Data)
        .then(res => {
          // console.log(res)
          if (res.status == 201) {
            this.loading = false;
            this.eventAlert = "success";
            this.eventMsg = "Successfully booked class";
            setTimeout(() => {
              this.$router.push("/student/STabs#Welcome");
            }, 400);

            setTimeout(() => {
              // this.birthday=false
              // this.ChangeTime=false
              this.eventAlert = "";
              this.eventMsg = "";
              let moduleId = self.moduleId;
              let packageId = self.packageId;
              // let className=self.className
              let studentId = Store.state.user.id;
              this.setClassDetails(moduleId, packageId, className, studentId);
              api.postData("student/view_classes").then(response => {
                // console.log(response)
                this.$store.dispatch("setClasses", response.data);
              });
              self.sheet = false;
            }, 1600);
          } else if (res.status == 200) {
            // console.log("Hello")
            this.loading = false;
            this.eventAlert = "warning";
            this.eventMsg = res.data.error.message;
          }
        })
        .catch(err => {
          this.loading = false;
          this.eventAlert = "warning";
          this.eventMsg = "Booking failed";
        });
    },
    setModulePopupData(item) {
      this.viewModulePopupData = item;
      this.viewModulePopup = true;
    }
  }
};
</script>

<style>
.v-picker__title__btn:not(.v-picker__title__btn--active) {
  display: none;
}
.v-date-picker-title {
  display: none !important;
  padding: 6px !important;
}
.v-picker__body {
  height: 67vh !important;
}
.v-btn.v-btn--outline {
  border: 1px solid #095697;
  /*background: #095697 !important;*/
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #095697 !important;
}
.v-btn--floating:not(.v-btn--depressed):not(.v-btn--flat) {
  -webkit-box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
}
.v-date-picker-table .v-btn.v-btn--active {
  color: #095697 !important;
}
.v-date-picker-years li.active {
  color: #095697 !important;
}
.v-picker__title {
  color: #095697 !important;
}
.v-date-picker-title__date {
  font-size: 22px !important;
  color: #095697 !important;
}
.v-date-picker-header {
  font-size: 15px !important;
}
/*.navigation .far, .fa {*/
/*font-size: 10px !important;*/
/*}*/
/*.v-date-picker-table{*/
/*padding: 0px !important;*/
/*}*/
.v-date-picker-table {
  padding: 9px 12px !important;
  height: 438px !important;
}
.v-date-picker-table table {
  height: 58vh !important;
}
.v-picker__body {
  width: 100% !important;
}
.theme--light.v-card {
  width: 100% !important;
}
.v-date-picker-title {
  /*color: rgba(0,0,0,0.87) !important;*/
}
</style>



// WEBPACK FOOTER //
// src/components/profile/student/new/CalenderBook.vue